import {
  GET_LAB,
  GET_LAB_FAIL,
  GET_LAB_SUCCESS,
  GET_LABS,
  GET_LABS_FAIL,
  GET_LABS_SUCCESS,
  ADD_NEW_LAB,
  ADD_LAB_SUCCESS,
  ADD_LAB_FAIL,
  UPDATE_LAB,
  UPDATE_LAB_SUCCESS,
  UPDATE_LAB_FAIL,
  DELETE_LAB,
  DELETE_LAB_SUCCESS,
  DELETE_LAB_FAIL,
  SET_STATE_LAB,
  UPDATE_LAB_STATUS
} from "./actionTypes"

export const setState = ( loading ) => ({
  type: SET_STATE_LAB,
  payload: loading,
})

export const getLabs = ( params ) => ({
  type: GET_LABS,
  payload: { params },
})

export const getLabsSuccess = (labs, totalPages, currentPage) => ({
  type: GET_LABS_SUCCESS,
  payload: { labs:labs, total:totalPages, currentPage:currentPage}
})

export const getLabsFail = error => ({
  type: GET_LABS_FAIL,
  payload: error,
})

export const addNewLab = lab => ({
  type: ADD_NEW_LAB,
  payload: lab,
})

export const addLabSuccess = lab => ({
  type: ADD_LAB_SUCCESS,
  payload: lab,
})  

export const addLabFail = error => ({
  type: ADD_LAB_FAIL,
  payload: error,
})

export const updateLab = lab => ({
  type: UPDATE_LAB,
  payload: lab,
})

export const updateLabStatus = lab => ({
  type: UPDATE_LAB_STATUS,
  payload: lab,
})

export const updateLabSuccess = lab => ({
  type: UPDATE_LAB_SUCCESS,
  payload: lab,
})

export const updateLabFail = error => ({
  type: UPDATE_LAB_FAIL,
  payload: error,
})

export const deleteLab = lab => ({
  type: DELETE_LAB,
  payload: lab,
})

export const deleteLabSuccess = id => ({
  type: DELETE_LAB_SUCCESS,
  id,
})

export const deleteLabFail = error => ({
  type: DELETE_LAB_FAIL,
  payload: error,
})

export const getLab = () => ({
  type: GET_LAB,
})

export const getLabSuccess = lab => ({
  type: GET_LAB_SUCCESS,
  payload: lab,
})

export const getLabFail = error => ({
  type: GET_LAB_FAIL,
  payload: error,
})
